module.exports = __webpack_public_path__ + "img/ws.169a2267.png";